// extracted by mini-css-extract-plugin
module.exports = {"VideoContainer":"DocumentInfoVideo_VideoContainer__2wiGu","PlayerContainer":"DocumentInfoVideo_PlayerContainer__NGBV8","PlayerWrapper":"DocumentInfoVideo_PlayerWrapper__x8wZS"};